/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCreateRoomRequestFromJSON(json) {
    return StreemApiCreateRoomRequestFromJSONTyped(json, false);
}
export function StreemApiCreateRoomRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdByUserSid': !exists(json, 'created_by_user_sid') ? undefined : json['created_by_user_sid'],
        'preferredCodec': !exists(json, 'preferred_codec') ? undefined : json['preferred_codec'],
        'referenceId': !exists(json, 'reference_id') ? undefined : json['reference_id'],
        'integrationId': !exists(json, 'integration_id') ? undefined : json['integration_id'],
    };
}
export function StreemApiCreateRoomRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'created_by_user_sid': value.createdByUserSid,
        'preferred_codec': value.preferredCodec,
        'reference_id': value.referenceId,
        'integration_id': value.integrationId,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiCreateRoomRequestPreferredCodec;
(function (StreemApiCreateRoomRequestPreferredCodec) {
    StreemApiCreateRoomRequestPreferredCodec["H264"] = "VIDEO_CODEC_H264";
    StreemApiCreateRoomRequestPreferredCodec["INVALID"] = "VIDEO_CODEC_INVALID";
    StreemApiCreateRoomRequestPreferredCodec["VP8"] = "VIDEO_CODEC_VP8";
    StreemApiCreateRoomRequestPreferredCodec["VP9"] = "VIDEO_CODEC_VP9";
})(StreemApiCreateRoomRequestPreferredCodec || (StreemApiCreateRoomRequestPreferredCodec = {}));
//# sourceMappingURL=StreemApiCreateRoomRequest.js.map